import { store } from '@/store.js'
export default class WindowUtils {
  /**
   * ウィンドウを取得
   * @param {string}  ウィンドウ名
   * @return {window} ウィンドウインスタンス
   */
  static getWindow(winName) {
    const windowInstance = store.getters.getWindowInstance
    return windowInstance[winName]
  }

  /**
   * 最大化されたウィンドウを開く
   * @param {string} ウィンドウ名
   * @param {object} クエリパラメータ値
   */
  static openMaximizedWindow(winName, paramQueryString) {
    let currentUrl = window.location.href
    let newWindow
    if (currentUrl.indexOf(paramQueryString) === -1) {
      currentUrl += currentUrl.indexOf('?') !== -1 ? '&' : '?' + paramQueryString
    }
    newWindow = window.open(currentUrl, winName, `titlebar=no,toolbar=no,location=no,menubar=no,width=${screen.availWidth},height=${screen.availHeight}`)
    let windowInstance = store.getters.getWindowInstance
    windowInstance[winName] = newWindow
    store.commit('setWindowInstance', windowInstance)
  }

  /**
   * ウィンドウシュートガードを閉じる
   * @param {string} ウィンドウ名
   */
  static closeWindow(winName) {
    const windowInstance = store.getters.getWindowInstance
    if (windowInstance && windowInstance[winName]) {
      windowInstance[winName].close()
      store.commit('setWindowInstance', {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/window.util.js